module.exports = __webpack_public_path__ + "img/10.168406cb.png";